import { getLevelForXp, getLevelProgress, getNextLevel } from "@/utils/levels";

interface LevelBadgeProps {
  totalXp: number;
  compact?: boolean;
}

export function LevelBadge({ totalXp, compact = false }: LevelBadgeProps) {
  const level = getLevelForXp(totalXp);
  const next = getNextLevel(totalXp);
  const progress = getLevelProgress(totalXp);

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-amber-100 text-xs font-bold text-amber-700">
          {level.level}
        </span>
        <span className="text-sm font-medium text-gray-700">{level.title}</span>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-amber-100 text-sm font-bold text-amber-700">
            {level.level}
          </span>
          <div>
            <p className="text-sm font-bold text-gray-900">{level.title}</p>
            <p className="text-xs text-gray-500">{totalXp.toLocaleString()} XP</p>
          </div>
        </div>
        {next && (
          <p className="text-xs text-gray-400">
            {next.xpRequired - totalXp} XP to {next.title}
          </p>
        )}
      </div>
      <div className="h-2.5 overflow-hidden rounded-full bg-gray-100">
        <div
          className="animate-progress-fill h-full rounded-full bg-amber-400 transition-all"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
